import { computed, unref } from 'vue-demi'
import _ from 'lodash'
import store from '@/store'
import { baseURL } from './consts'

export const useBaseUrl = () => {
  const getBaseUrl = computed(() => {
    const region = store.getters['regions/currentRegion']
    if (!_.isEmpty(region.name)) {
      return `/${region.name.toLowerCase()}${baseURL}`
    }
    return baseURL
  })
  return unref(getBaseUrl)
}
